module.exports = __webpack_public_path__ + "static/media/cancelado.54ce1bbf.svg";